module.exports = __webpack_public_path__ + "static/media/s_sky_blue.103146d9.mp3";